var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionListTemplate',{attrs:{"screenConfig":_vm.data,"backButtonRoute":'/settings/user',"setLoading":_vm.setLoading,"persistenceKey":'user-list',"backButtonEnable":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }